import * as React from 'react';
import { cn } from '@/utils/cn';
import { BsEye, BsEyeSlash } from '@icons';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <div className="relative w-full">
        <input
          type={type === 'password' && showPassword ? 'text' : type}
          className={cn(
            'flex h-10 w-full flex-col justify-center rounded-md border border-border-primary bg-transparent py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            className,
          )}
          ref={ref}
          {...props}
        />
        {type === 'password' && (
          <div
            className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? (
              <BsEyeSlash className="h-5 w-5 text-gray-500" />
            ) : (
              <BsEye className="h-5 w-5 text-gray-500" />
            )}
          </div>
        )}
      </div>
    );
  },
);

Input.displayName = 'Input';

export { Input };
